import { focusOutline } from '@barracuda/shared/styles/focus';

export const logoutButtonStyle = {
  cursor: 'pointer',
  textTransform: 'none',
  justifyContent: 'flex-start',
  color: 'inherit',
  minWidth: 'auto',
  '&:focus-visible': focusOutline
};

export const logoutMobileMenuButtonStyle = {
  ...logoutButtonStyle,
  flexGrow: 1,
  padding: '8px 16px',
  width: '100%'
};
